<template>
  <div class="page inteboStaff" style="background-color: #ffffff">
    <el-container style="height: 100%">
      <el-header style="height: 40px">
        <el-form :inline="true" :model="params" class="demo-form-inline">
          <el-form-item label="职位">
            <el-select v-model="params.posid" style="width: 120px" size="mini" placeholder="" @change="posChange">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.constantname" :value="item.constantid" :key="key" v-for="(item,key) in posData"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="params.status" @change="statusChange">离职</el-checkbox>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" @click="openRz" size="mini">入职</el-button>
              <el-button type="primary" @click="openTeam" size="mini">团队</el-button>
          </el-form-item>
        </el-form>
      </el-header>
      <el-main style="height: 100%">
        <el-table height="calc(100%)"  border :data="staffInfos" size="mini" style="text-align: center" highlight-current-row :row-class-name="tableRowClassName">
          <el-table-column label="员工姓名"  align="center"prop="staffname"></el-table-column>
          <el-table-column label="职位"  align="center"prop="posname"></el-table-column>
          <el-table-column label="手机号码" width="110" align="center"prop="phone"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status==1">
                <el-button @click="updateInteboStaff(scope.row,4)" type="text" size="small">职位调整</el-button>
                <el-button @click="updateInteboStaffStatus(scope.row,2)" type="text" size="small">离职</el-button>
                <el-button @click="openStaffChange(scope.row,4)" type="text" size="small">异动历史</el-button>
              </div>
              <div v-else>
                <el-button @click="updateInteboStaff(scope.row,3)" type="text" size="small">重新入职</el-button>
                  <el-button @click="openStaffChange(scope.row,4)" type="text" size="small">异动历史</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
    data() {
        return {
            params: {
                posid: "",
                status: false
            },
            staffInfos: [],
            posData: [],
        }
    },
    created() {
        this.getPosData();
        this.getInteboStaffByParam();
        /*let userId = this.$getUrlKey("userId");
    let code = this.$getUrlKey("code");
    if (userId || code) {
      if (userId) {
        this.getCorpUserInfo(userId);
      }
    } else {
        //window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getInteboCorpCode?state="+encodeURIComponent("http://intebo.shmiaojie.cn/#/staffinfo");
      //window.location.href="http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechat/getCorpidCode?state=7";
      //window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCode?state=8";
    }*/
    },
    methods: {
        openTeam(){
            this.$router.push({
                path: '/inteboteam'
            });
        },
        openStaffChange(row) {
            this.$router.push({
                path: '/staffchangehistory', query: {
                    staffid: row.staffid
                }
            });
        },
        getCorpUserInfo(staffid) {
            this.$post("wechat/getInteboCorpUserInfo", {staffid: staffid}).then(res => {
                if (res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        //如果钉钉没找到就关闭页面
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        this.getPosData();
                        this.getInteboStaffByParam();
                    }
                }
            });
        },
        tableRowClassName({row, rowIndex}) {
            if (row.status != 1) {
                return 'warning-row';
            }
        },
        updateInteboStaffStatus(row, status) {
            this.$router.push({
                path: '/staffleave', query: {
                    type: "update",
                    staffid: row.staffid
                }
            });
        },
        updateInteboStaff(row, type) {
            this.$router.push({
                path: '/staffposchange', query: {
                    type: type,
                    staffid: row.staffid
                }
            });
        },
        statusChange(val) {
            this.getInteboStaffByParam();
        },
        openRz() {
            this.$router.push({
                path: '/addstaffinfo', query: {
                    type: "add"
                }
            });
        },
        getPosData() {
            this.$post("basis/getConstantInfo", {
                storeid: "320c07ba76e94b0d8735aefe4470c07a",
                constanttype: "YTBZW",
                lv: 2,
                status: 0,
                guid: ""
            }).then(res => {
                if (res.sucess) {
                    this.posData = res.object;
                }
            });
        },
        getInteboStaffByParam() {
            let status = 1;
            if (this.params.status) {
                status = 0;
            }
            this.$post("inteboStaff/getInteboStaffByParam", {posid: this.params.posid, status: status}).then(res => {
                if (res.sucess) {
                    this.staffInfos = res.object;
                }
            });
        },
        posChange(val) {
            this.getInteboStaffByParam();
        },
    }
}
</script>

<style style lang="scss" rel="stylesheet/scss">
.inteboStaff .el-main{
  padding:0px;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/page/intebo/intebostaff/staffinfo.vue